module.exports = __webpack_public_path__ + "static/media/zonaHFace.dd5c2fcc.jpg";